import script from "./name_seach.vue?vue&type=script&setup=true&lang=js"
export * from "./name_seach.vue?vue&type=script&setup=true&lang=js"

import "./name_seach.vue?vue&type=style&index=0&id=7ff73c3e&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff73c3e"]])

export default __exports__